import React, { useRef } from "react";
import { broadcastAnd, setRoom, addChat } from "../redux/actions";
import { connect } from "react-redux";
import MiscUtil from "../lib/MiscUtil";
import FixedClock from "../lib/FixedClock";
import styled from "styled-components";

const StyledProgress=styled.progress`
    min-width: 100px;
    margin-top: 15px;
    margin-bottom: 15px
`;

const UnconnectedProgressBar = (props) => {
    const progressRef = useRef(null);

    const handleProgressClick = (e) => {
        let pos = e.clientX - progressRef.current.getBoundingClientRect().left;
        let width = progressRef.current.getBoundingClientRect().width;

        let progress_percent = (pos / width);
        let progress_secs = (progress_percent * props.videoLength).toFixed();

        props.broadcastAnd({
            nick_name: props.nickName,
            room_key: props.roomKey,
            namespace: "control",
            action: setRoom({ ...getFullRoomDetails(), video_position: progress_secs })
        });
        sendChat("[Skipped to " + MiscUtil.secsToHHMMSS(progress_secs) + "]");
    };

    const getFullRoomDetails = () => ({
        is_playing: props.isPlaying,
        video_url: props.videoUrl,
        subtitle_url: props.subtitleUrl,
        video_position: props.idealPosition,
        video_position_timestamp: FixedClock.utc(),
        video_length: props.videoLength,
        password: props.password
    });

    const sendChat = (msg) => {
        props.broadcastAnd({
            nick_name: props.nickName,
            room_key: props.roomKey,
            namespace: "chat",
            action: addChat(props.nickName, msg)
        });
    };

    const safeCalculateProgress = () => {
        return (props.videoLength > 0) ? (props.idealPosition * 100 / props.videoLength) : 0;
    };

    return (
        <StyledProgress 
            ref={progressRef} 
            className="progress" 
            value={safeCalculateProgress()} 
            max="100" 
            onClick={handleProgressClick}>
        </StyledProgress>
    );
};

const mapStateToProps = state => ({ 
    nickName: state.user.nick_name,
    roomKey: state.user.room_key,
    videoLength: state.room.video_length,
    idealPosition: state.user.ideal_position,
    isPlaying: state.room.is_playing,
    videoUrl: state.room.video_url,
    subtitleUrl: state.room.subtitle_url,
    password: state.room.password
 });

export const ProgressBar = connect(mapStateToProps,{ broadcastAnd, addChat })(UnconnectedProgressBar);


